const TwoArrowsIcon = ({
  width = '128',
  height = '128',
  style = {},
  primaryColor = '',
  secondaryColor = '',
}) => (
  <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg" style={style}>
    <g>
      <title>background</title>
      <rect fill="none" id="canvas_background" height={height} width={width} y="-1" x="-1" />
    </g>
    <g>
      <title>Layer 1</title>
      <path
        id="svg_1"
        fillRule="evenodd"
        fill={primaryColor}
        d="m6.216966,1.287113c0.55228,0 1,0.44772 1,1l0,10c0,0.5523 -0.44772,1 -1,1c-0.55228,0 -1,-0.4477 -1,-1l0,-10c0,-0.55228 0.44772,-1 1,-1z"
        clipRule="evenodd"
      />
      <path
        id="svg_2"
        fillRule="evenodd"
        fill={secondaryColor}
        d="m14.063623,7.091355c0.5523,0 1,0.44772 1,1l0,10c0,0.5523 -0.4477,1 -1,1c-0.5523,0 -1,-0.4477 -1,-1l0,-10c0,-0.55228 0.4477,-1 1,-1z"
        clipRule="evenodd"
      />
      <path
        id="svg_3"
        fillRule="evenodd"
        fill={primaryColor}
        d="m5.509856,1.580003c0.39053,-0.39052 1.02369,-0.39052 1.41422,0l2.99999,3c0.3905,0.39053 0.3905,1.02369 0,1.41422c-0.3905,0.39052 -1.02368,0.39052 -1.41421,0l-2.29289,-2.2929l-2.29289,2.2929c-0.39053,0.39052 -1.02369,0.39052 -1.41422,0c-0.39052,-0.39053 -0.39052,-1.02369 0,-1.41422l3,-3z"
        clipRule="evenodd"
      />
      <path
        id="svg_4"
        fillRule="evenodd"
        fill={secondaryColor}
        d="m14.770723,18.798455c-0.3905,0.3905 -1.0237,0.3905 -1.4142,0l-3,-3c-0.3905,-0.3905 -0.3905,-1.0237 0,-1.4142c0.3905,-0.3905 1.0237,-0.3905 1.4142,0l2.2929,2.2929l2.2929,-2.2929c0.3905,-0.3905 1.0237,-0.3905 1.4142,0c0.3905,0.3905 0.3905,1.0237 0,1.4142l-3,3z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export default TwoArrowsIcon;
